export interface BodyCreateDevice {
  id_empresa: string;
  id_sucursal: string;
  tipo_dispositivo: string;
  estado: string;
  nombre_dispositivo: string;
  ip: string;
  serial: string;
  tipo_acceso: string;
  camara_master: number;
  id_camara_master?: number;
  ultima_actualizacion: Date;
  fecha_creacion: Date;
  fecha_modificacion: Date;
  usuario: string;
  contrasena: string;
  incluye_monitoreo: boolean;
  factor_conversion: number;
  ids_sectores: string[];
}

export interface ResponseDeviceAction {
  column_name: ResultDeviceAction;
}

export interface ResultDeviceAction {
  id: number;
  message: string;
}

export interface BodyUpdateDevice {
  id_dispositivo: string;
  id_sucursal: string;
  tipo_dispositivo: string;
  estado: string;
  nombre_dispositivo: string;
  ip: string;
  serial: string;
  camara_master: number;
  id_camara_master?: number;
  ultima_actualizacion: Date;
  fecha_modificacion: Date;
  usuario: string;
  contrasena: string;
  incluye_monitoreo: boolean;
  factor_conversion: number;
  ids_sectores: string[];
}

export interface ResponseListDevices {
  dispositivos: Device[];
}

export interface Device {
  IP:                     string;
  Id:                     number;
  Tipo:                   string;
  Estado:                 string;
  Nombre:                 string;
  Serial:                 string;
  Empresa:                string;
  Usuario:                null | string;
  Sectores:               Sectors[];
  Sucursal:               string;
  Monitoreo:              boolean;
  "Id Empresa":           number;
  Contraseña:             null | string;
  "Id Sucursal":          number;
  "Tipo Acceso":          string;
  "Cámara Master":        string;
  "Id Cámara Master":     number;
  "Factor de Conversión": number;
  "Nombre Cámara Master": string;
}

export interface Sectors {
  id_sector:     number;
  nombre_sector: string;
}
